import { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { updateExhibitor, getExhibitorById } from "api/exhibitor.api";
import ExhibitorForm from "components/exhibitor/ExhibitorForm";
import Alert from "components/common/Alert";

export default function EditExhibitor() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [initialData, setInitialData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState("");

  useEffect(() => {
    fetchExhibitor();
  }, []);

  const fetchExhibitor = async () => {
    try {
      const res = await getExhibitorById(id);
      console.log("data", res)
      setInitialData(res.data?.data );
    } catch (err) {
      console.error("Fetch failed", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (fd) => {
    try {
      await updateExhibitor(id, fd);
      navigate("/admin/exhibitors");
    } catch (err) {
      console.error(err);
      setAlert(err.response?.data?.message || "Something went wrong");
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <ExhibitorForm
      initialData={initialData}
      onSubmit={handleSubmit}
      onBack={() => navigate("/admin/exhibitors")}
      alert={alert}
      setAlert={setAlert}
    />
  );
}
